<template>
    <div>
        <el-form style="width: 1500px;" :inline="true" :model="feedForm"  :rules="feedRules"  ref="feedForm" class="demo-form-inline" size="small">
            <el-row :gutter="0">
                <el-col :span="4">
                    <el-form-item label-width="100px" label="日期：" prop="feedDate">
                        <el-date-picker
                                v-model="feedForm.feedDate"
                                type="date"
                                placeholder=""
                                disabled="disabled"
                                style="width:140px"
                        >
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="車號：" prop="carNumber">
                        <el-input placeholder=""  clearable v-model="feedForm.carNumber" style="width: 100px;"  disabled="disabled">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="積車" prop="productCar">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldproductCar" v-model="feedForm.productCar" @change="validateChange(feedForm.productCar,feedOldForm.oldproductCar,'productCar')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.productCar" @change="validateChange(feedForm.productCar,feedOldForm.oldproductCar,'productCar')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">部</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="搬花網" prop="wireMesh">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldwireMesh" v-model="feedForm.wireMesh" @change="validateChange(feedForm.wireMesh,feedOldForm.oldwireMesh,'wireMesh')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.wireMesh" @change="validateChange(feedForm.wireMesh,feedOldForm.oldwireMesh,'wireMesh')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">個</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="110px" label="膠紙冚" prop="tape">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldtape" v-model="feedForm.tape" @change="validateChange(feedForm.tape,feedOldForm.oldtape,'tape')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.tape" @change="validateChange(feedForm.tape,feedOldForm.oldtape,'tape')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">個</span>
                    </el-form-item>
                </el-col>
               <!-- <el-col :span="4">
                    <el-form-item label-width="100px" label="扎車(坑紙)" prop="oneCar">
						<el-input v-if="feedForm.status!=1"  :placeholder="feedOldForm.oldoneCar"  clearable v-model="feedForm.oneCar"  @change="validateChange(feedForm.oneCar,feedOldForm.oldoneCar,'oneCar')" :disabled="disabledNum" style="width: 100px;"></el-input>
												
						 <el-input v-else  placeholder="" clearable v-model="feedForm.oneCar"  @change="validateChange(feedForm.oneCar,feedOldForm.oldoneCar,'oneCar')" :disabled="disabledNum" style="width: 100px;">
						 </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="扎車(地膠)" prop="twoCar">
                        <el-input v-if="feedForm.status!=1"  :placeholder="feedOldForm.oldtwoCar"  clearable v-model="feedForm.twoCar" @change="validateChange(feedForm.twoCar,feedOldForm.oldtwoCar,'twoCar')" :disabled="disabledNum" style="width: 100px;">
                        </el-input>
						<el-input v-else placeholder=""   clearable v-model="feedForm.twoCar" @change="validateChange(feedForm.twoCar,feedOldForm.oldtwoCar,'twoCar')" :disabled="disabledNum" style="width: 100px;">
						</el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="110px" label="扎車(縐紋紙)" prop="threeCar">
                        <el-input v-if="feedForm.status!=1" :placeholder="feedOldForm.oldthreeCar"  clearable v-model="feedForm.threeCar" @change="validateChange(feedForm.threeCar,feedOldForm.oldthreeCar,'threeCar')" :disabled="disabledNum" style="width: 100px;">
                        </el-input>
                        <el-input v-else placeholder=""  clearable v-model="feedForm.threeCar" @change="validateChange(feedForm.threeCar,feedOldForm.oldthreeCar,'threeCar')" :disabled="disabledNum" style="width: 100px;">
                        </el-input>
                    </el-form-item>
                </el-col>-->
            </el-row>
            <el-row :gutter="0">
                <el-col :span="4">
                    <el-form-item label-width="100px" label="坑紙"   prop="pitPaper">
                        <el-input v-if="feedForm.status!=1" :placeholder="feedOldForm.oldpitPaper" v-model="feedForm.pitPaper" @change="validateChange(feedForm.pitPaper,feedOldForm.oldpitPaper,'pitPaper')" :disabled="disabledNum" clearable style="width: 100px;" >
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.pitPaper" @change="validateChange(feedForm.pitPaper,feedOldForm.oldpitPaper,'pitPaper')" :disabled="disabledNum" clearable style="width: 100px;" >
                        </el-input>
                        <span style="color: #000000">卷</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="報紙" prop="newsPaper">
                        <el-input  v-if="feedForm.status!=1" :placeholder="feedOldForm.oldnewsPaper" v-model="feedForm.newsPaper" @change="validateChange(feedForm.newsPaper,feedOldForm.oldnewsPaper,'newsPaper')" :disabled="disabledNum" clearable style="width: 100px;" >
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.newsPaper" @change="validateChange(feedForm.newsPaper,feedOldForm.oldnewsPaper,'newsPaper')" :disabled="disabledNum" clearable style="width: 100px;" >
                        </el-input>
                        <span style="color: #000000">卷</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="卜卜膠" prop="buBu">
                        <el-input v-if="feedForm.status!=1" :placeholder="feedOldForm.oldbuBu" v-model="feedForm.buBu" @change="validateChange(feedForm.buBu,feedOldForm.oldbuBu,'buBu')"  clearable style="width: 100px;"  :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.buBu" @change="validateChange(feedForm.buBu,feedOldForm.oldbuBu,'buBu')"  clearable style="width: 100px;"  :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">卷</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="拷貝紙" prop="copyPaper">
                        <el-input v-if="feedForm.status!=1" :placeholder="feedOldForm.oldcopyPaper" v-model="feedForm.copyPaper" @change="validateChange(feedForm.copyPaper,feedOldForm.oldcopyPaper,'copyPaper')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.copyPaper" @change="validateChange(feedForm.copyPaper,feedOldForm.oldcopyPaper,'copyPaper')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">卷</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="110px" label="毡" prop="mat">
                        <el-input v-if="feedForm.status!=1" :placeholder="feedOldForm.oldmat" v-model="feedForm.mat" @change="validateChange(feedForm.mat,feedOldForm.oldmat,'mat')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.mat" @change="validateChange(feedForm.mat,feedOldForm.oldmat,'mat')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">盒</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="0">
                <el-col :span="4">
                    <el-form-item label-width="100px" label="保鮮紙" prop="tinFoil">
                        <el-input v-if="feedForm.status!=1" :placeholder="feedOldForm.oldtinFoil" v-model="feedForm.tinFoil" @change="validateChange(feedForm.tinFoil,feedOldForm.oldtinFoil,'tinFoil')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.tinFoil" @change="validateChange(feedForm.tinFoil,feedOldForm.oldtinFoil,'tinFoil')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">卷</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="高木箱" prop="azusa">
                        <el-input v-if="feedForm.status!=1" :placeholder="feedOldForm.oldazusa" v-model="feedForm.azusa" @change="validateChange(feedForm.azusa,feedOldForm.oldazusa,'azusa')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input  v-else placeholder="" v-model="feedForm.azusa" @change="validateChange(feedForm.azusa,feedOldForm.oldazusa,'azusa')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">個</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="矮木箱" prop="shortWood">
                        <el-input v-if="feedForm.status!=1" :placeholder="feedOldForm.oldshortWood" v-model="feedForm.shortWood" @change="validateChange(feedForm.shortWood,feedOldForm.oldshortWood,'shortWood')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input  v-else placeholder="" v-model="feedForm.shortWood" @change="validateChange(feedForm.shortWood,feedOldForm.oldshortWood,'shortWood')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">個</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="鐵車" prop="ironCar">
                        <el-input v-if="feedForm.status!=1" :placeholder="feedOldForm.oldironCar" v-model="feedForm.ironCar" @change="validateChange(feedForm.ironCar,feedOldForm.oldironCar,'ironCar')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.ironCar" @change="validateChange(feedForm.ironCar,feedOldForm.oldironCar,'ironCar')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">部</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="110px" label="車仔" prop="chelsea">
                        <el-input v-if="feedForm.status!=1" :placeholder="feedOldForm.oldchelsea" v-model="feedForm.chelsea" @change="validateChange(feedForm.chelsea,feedOldForm.oldchelsea,'chelsea')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.chelsea" @change="validateChange(feedForm.chelsea,feedOldForm.oldchelsea,'chelsea')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">部</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="0">
                <el-col :span="4">
                    <el-form-item label-width="100px" label="軟紙"  prop="softPaper">
                        <el-input v-if="feedForm.status!=1" :placeholder="feedOldForm.oldsoftPaper" v-model="feedForm.softPaper"@change="validateChange(feedForm.softPaper,feedOldForm.oldsoftPaper,'softPaper')"  clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input  v-else placeholder="" v-model="feedForm.softPaper"@change="validateChange(feedForm.softPaper,feedOldForm.oldsoftPaper,'softPaper')"  clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">扎</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="爛紙" prop="lousyPaper">
                        <el-input v-if="feedForm.status!=1" :placeholder="feedOldForm.oldlousyPaper" v-model="feedForm.lousyPaper" @change="validateChange(feedForm.lousyPaper,feedOldForm.oldlousyPaper,'lousyPaper')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.lousyPaper" @change="validateChange(feedForm.lousyPaper,feedOldForm.oldlousyPaper,'lousyPaper')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">盒</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="防潮珠" prop="moistureproof">
                        <el-input v-if="feedForm.status!=1" :placeholder="feedOldForm.oldmoistureproof" v-model="feedForm.moistureproof" @change="validateChange(feedForm.moistureproof,feedOldForm.oldmoistureproof,'moistureproof')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.moistureproof" @change="validateChange(feedForm.moistureproof,feedOldForm.oldmoistureproof,'moistureproof')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">袋</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="電批" prop="electric">
                        <el-input v-if="feedForm.status!=1" :placeholder="feedOldForm.oldelectric" v-model="feedForm.electric" @change="validateChange(feedForm.electric,feedOldForm.oldelectric,'electric')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.electric" @change="validateChange(feedForm.electric,feedOldForm.oldelectric,'electric')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">個</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="110px" label="叉" prop="fork">
                        <el-input v-if="feedForm.status!=1" :placeholder="feedOldForm.oldfork" v-model="feedForm.fork" @change="validateChange(feedForm.fork,feedOldForm.oldfork,'fork')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.fork" @change="validateChange(feedForm.fork,feedOldForm.oldfork,'fork')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">個</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="0">
                <el-col :span="4">
                    <el-form-item label-width="100px" label="散箱" prop="bulktank">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldbulktank" v-model="feedForm.bulktank" @change="validateChange(feedForm.bulktank,feedOldForm.oldbulktank,'bulktank')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.bulktank" @change="validateChange(feedForm.bulktank,feedOldForm.oldbulktank,'bulktank')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">個</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="地膠" prop="toGlue">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldtoGlue" v-model="feedForm.toGlue" @change="validateChange(feedForm.toGlue,feedOldForm.oldtoGlue,'toGlue')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.toGlue" @change="validateChange(feedForm.toGlue,feedOldForm.oldtoGlue,'toGlue')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">卷</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="膠紙" prop="gummedPaper">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldgummedPaper" v-model="feedForm.gummedPaper" @change="validateChange(feedForm.gummedPaper,feedOldForm.oldgummedPaper,'gummedPaper')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.gummedPaper" @change="validateChange(feedForm.gummedPaper,feedOldForm.oldgummedPaper,'gummedPaper')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">卷</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="铁笼" prop="cage">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldcage" v-model="feedForm.cage" @change="validateChange(feedForm.cage,feedOldForm.oldcage,'cage')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.cage" @change="validateChange(feedForm.cage,feedOldForm.oldcage,'cage')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">件</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="110px" label="夾板(長)" prop="plywood">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldplywood" v-model="feedForm.plywood" @change="validateChange(feedForm.plywood,feedOldForm.oldplywood,'plywood')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.plywood" @change="validateChange(feedForm.plywood,feedOldForm.oldplywood,'plywood')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">件</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="0">
                <el-col :span="4">
                    <el-form-item label-width="100px" label="紙卡板" prop="paperCardBoard">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldpaperCardBoard" v-model="feedForm.paperCardBoard" @change="validateChange(feedForm.paperCardBoard,feedOldForm.oldpaperCardBoard,'paperCardBoard')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.paperCardBoard" @change="validateChange(feedForm.paperCardBoard,feedOldForm.oldpaperCardBoard,'paperCardBoard')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">件</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="開木箱工具" prop="tool">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldtool" v-model="feedForm.tool" @change="validateChange(feedForm.tool,feedOldForm.oldtool,'tool')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.tool" @change="validateChange(feedForm.tool,feedOldForm.oldtool,'tool')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">套</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="膠(110cm)" prop="glue">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldglue" v-model="feedForm.glue" @change="validateChange(feedForm.glue,feedOldForm.oldglue,'glue')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.glue" @change="validateChange(feedForm.glue,feedOldForm.oldglue,'glue')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">件</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="Plasma" prop="plasma">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldplasma" v-model="feedForm.plasma" @change="validateChange(feedForm.plasma,feedOldForm.oldplasma,'plasma')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.plasma" @change="validateChange(feedForm.plasma,feedOldForm.oldplasma,'plasma')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">個</span>
                    </el-form-item>
                </el-col> <el-col :span="4">
                <el-form-item label-width="110px" label="縐紋紙" prop="crepePaper">
                    <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldcrepePaper" v-model="feedForm.crepePaper" @change="validateChange(feedForm.crepePaper,feedOldForm.oldcrepePaper,'crepePaper')" clearable style="width: 100px;" :disabled="disabledNum">
                    </el-input>
                    <el-input v-else placeholder="" v-model="feedForm.crepePaper" @change="validateChange(feedForm.crepePaper,feedOldForm.oldcrepePaper,'crepePaper')" clearable style="width: 100px;" :disabled="disabledNum">
                    </el-input>
                    <span style="color: #000000">卷</span>
                </el-form-item>
            </el-col>
            </el-row>
            <el-row :gutter="0">
                <el-col :span="4">
                    <el-form-item label-width="100px" label="平衣" prop="flatClothing">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldflatClothing" v-model="feedForm.flatClothing" @change="validateChange(feedForm.flatClothing,feedOldForm.oldflatClothing,'flatClothing')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.flatClothing" @change="validateChange(feedForm.flatClothing,feedOldForm.oldflatClothing,'flatClothing')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">個</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="冰箱" prop="refrigerator">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldrefrigerator" v-model="feedForm.refrigerator" @change="validateChange(feedForm.refrigerator,feedOldForm.oldrefrigerator,'refrigerator')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.refrigerator" @change="validateChange(feedForm.refrigerator,feedOldForm.oldrefrigerator,'refrigerator')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">個</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="黑色橡筋" prop="elastic">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldelastic" v-model="feedForm.elastic" @change="validateChange(feedForm.elastic,feedOldForm.oldelastic,'elastic')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.elastic" @change="validateChange(feedForm.elastic,feedOldForm.oldelastic,'elastic')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">扎</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="紙板" prop="cardboard">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldcardboard" v-model="feedForm.cardboard" @change="validateChange(feedForm.cardboard,feedOldForm.oldcardboard,'cardboard')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.cardboard" @change="validateChange(feedForm.cardboard,feedOldForm.oldcardboard,'cardboard')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">塊</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="110px" label="企身" prop="stiff">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldstiff" v-model="feedForm.stiff" @change="validateChange(feedForm.stiff,feedOldForm.oldstiff,'stiff')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.stiff" @change="validateChange(feedForm.stiff,feedOldForm.oldstiff,'stiff')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">套</span>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="0">
                <el-col :span="4">
                    <el-form-item label-width="100px" label="地台板(長)" prop="lengthFloor">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldlengthFloor" v-model="feedForm.lengthFloor" @change="validateChange(feedForm.lengthFloor,feedOldForm.oldlengthFloor,'lengthFloor')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.lengthFloor" @change="validateChange(feedForm.lengthFloor,feedOldForm.oldlengthFloor,'lengthFloor')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">件</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="地台板(短)" prop="shortFloor">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldshortFloor" v-model="feedForm.shortFloor" @change="validateChange(feedForm.shortFloor,feedOldForm.oldshortFloor,'shortFloor')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.shortFloor" @change="validateChange(feedForm.shortFloor,feedOldForm.oldshortFloor,'shortFloor')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">件</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="吊繩" prop="theWire">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldtheWire" v-model="feedForm.theWire" @change="validateChange(feedForm.theWire,feedOldForm.oldtheWire,'theWire')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.theWire" @change="validateChange(feedForm.theWire,feedOldForm.oldtheWire,'theWire')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">套</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="滑潤" prop="smooth">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldsmooth" v-model="feedForm.smooth"@change="validateChange(feedForm.smooth,feedOldForm.oldsmooth,'smooth')"  clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.smooth"@change="validateChange(feedForm.smooth,feedOldForm.oldsmooth,'smooth')"  clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">套</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="110px" label="膠(120cm)" prop="oneGlue">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldoneGlue" v-model="feedForm.oneGlue" @change="validateChange(feedForm.oneGlue,feedOldForm.oldoneGlue,'oneGlue')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.oneGlue" @change="validateChange(feedForm.oneGlue,feedOldForm.oldoneGlue,'oneGlue')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">件</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="0">
                <el-col :span="4">
                    <el-form-item label-width="100px" label="紙盒(新)">
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="紙盒(舊)">
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="梳化套：">
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="床褥套：">
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="110px" label="白水松：">
                    </el-form-item>
                </el-col>

            </el-row>
            <el-row :gutter="0">
                <el-col :span="4">
                    <el-form-item label-width="100px" label="新大" prop="big">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.agedbig" v-model="feedForm.big" @change="validateChange(feedForm.big,feedOldForm.agedbig,'big')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.big" @change="validateChange(feedForm.big,feedOldForm.agedbig,'big')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">個</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="舊大" prop="oldBig">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldoldBig" v-model="feedForm.oldBig" @change="validateChange(feedForm.oldBig,feedOldForm.oldoldBig,'oldBig')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.oldBig" @change="validateChange(feedForm.oldBig,feedOldForm.oldoldBig,'oldBig')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">個</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="3座位" prop="threeSeats">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldthreeSeats" v-model="feedForm.threeSeats" @change="validateChange(feedForm.threeSeats,feedOldForm.oldthreeSeats,'threeSeats')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.threeSeats" @change="validateChange(feedForm.threeSeats,feedOldForm.oldthreeSeats,'threeSeats')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">張</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="6呎" prop="sixRuler">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldsixRuler" v-model="feedForm.sixRuler" @change="validateChange(feedForm.sixRuler,feedOldForm.oldsixRuler,'sixRuler')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.sixRuler" @change="validateChange(feedForm.sixRuler,feedOldForm.oldsixRuler,'sixRuler')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">張</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="110px" label="1吋" prop="oneSmall">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldoneSmall" v-model="feedForm.oneSmall" @change="validateChange(feedForm.oneSmall,feedOldForm.oldoneSmall,'oneSmall')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.oneSmall" @change="validateChange(feedForm.oneSmall,feedOldForm.oldoneSmall,'oneSmall')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">袋</span>
                    </el-form-item>
                </el-col>

            </el-row>
            <el-row :gutter="0">
                <el-col :span="4">
                    <el-form-item label-width="100px" label="新中" prop="inthe">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.agedinthe" v-model="feedForm.inthe" @change="validateChange(feedForm.inthe,feedOldForm.agedinthe,'inthe')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.inthe" @change="validateChange(feedForm.inthe,feedOldForm.agedinthe,'inthe')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">個</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="舊中" prop="oldInthe">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldoldInthe" v-model="feedForm.oldInthe" @change="validateChange(feedForm.oldInthe,feedOldForm.oldoldInthe,'oldInthe')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.oldInthe" @change="validateChange(feedForm.oldInthe,feedOldForm.oldoldInthe,'oldInthe')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">個</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="2座位" prop="twoSeats">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldtwoSeats" v-model="feedForm.twoSeats" @change="validateChange(feedForm.twoSeats,feedOldForm.oldtwoSeats,'twoSeats')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.twoSeats" @change="validateChange(feedForm.twoSeats,feedOldForm.oldtwoSeats,'twoSeats')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">張</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="5呎" prop="fiveRuler">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldfiveRuler" v-model="feedForm.fiveRuler" @change="validateChange(feedForm.fiveRuler,feedOldForm.oldfiveRuler,'fiveRuler')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.fiveRuler" @change="validateChange(feedForm.fiveRuler,feedOldForm.oldfiveRuler,'fiveRuler')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">張</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="110px" label="半吋" prop="small">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldsmall" v-model="feedForm.small" @change="validateChange(feedForm.small,feedOldForm.oldsmall,'small')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.small" @change="validateChange(feedForm.small,feedOldForm.oldsmall,'small')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">袋</span>
                    </el-form-item>
                </el-col>

            </el-row>
            <el-row :gutter="0">
                <el-col :span="4">
                    <el-form-item label-width="100px" label="新細" prop="fine">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.agedfine" v-model="feedForm.fine" @change="validateChange(feedForm.fine,feedOldForm.agedfine,'fine')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.fine" @change="validateChange(feedForm.fine,feedOldForm.agedfine,'fine')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">個</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="舊細" prop="oldFine">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldoldFine" v-model="feedForm.oldFine" @change="validateChange(feedForm.oldFine,feedOldForm.oldoldFine,'oldFine')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.oldFine" @change="validateChange(feedForm.oldFine,feedOldForm.oldoldFine,'oldFine')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">個</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="1座位" prop="oneSeats">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldoneSeats" v-model="feedForm.oneSeats" @change="validateChange(feedForm.oneSeats,feedOldForm.oldoneSeats,'oneSeats')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.oneSeats" @change="validateChange(feedForm.oneSeats,feedOldForm.oldoneSeats,'oneSeats')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">張</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="4呎" prop="fourRuler">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldfourRuler" v-model="feedForm.fourRuler" @change="validateChange(feedForm.fourRuler,feedOldForm.oldfourRuler,'fourRuler')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.fourRuler" @change="validateChange(feedForm.fourRuler,feedOldForm.oldfourRuler,'fourRuler')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">張</span>
                    </el-form-item>
                </el-col>

            </el-row>
            <el-row :gutter="0">
                <el-col :span="4">
                    <el-form-item label-width="100px" label="">
                        <span style="color: #000000"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="">
                        <span style="color: #000000"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label-width="100px" label="">
                        <span style="color: #000000"></span>
                    </el-form-item>
                </el-col>

                <el-col :span="4">
                    <el-form-item label-width="100px" label="3呎" prop="threeRuler">
                        <el-input v-if="feedForm.status!=1":placeholder="feedOldForm.oldthreeRuler" v-model="feedForm.threeRuler" @change="validateChange(feedForm.threeRuler,feedOldForm.oldthreeRuler,'threeRuler')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <el-input v-else placeholder="" v-model="feedForm.threeRuler" @change="validateChange(feedForm.threeRuler,feedOldForm.oldthreeRuler,'threeRuler')" clearable style="width: 100px;" :disabled="disabledNum">
                        </el-input>
                        <span style="color: #000000">張</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="0">
                <el-col :span="23">
                    <el-form-item label-width="100px" label="其他：" prop="oneOther">
                        <el-input placeholder=""   type="textarea"
                                  :autosize="{minRows: 4,maxRows: 4}"
                                  v-model="feedForm.oneOther" clearable style="width: 900px;">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="0" style="height: 45px">
                <el-col :span="23">
                </el-col>
            </el-row>
            <el-row :gutter="0">
                <el-col :span="23">
                    <el-form-item label-width="100px" label="送盒：">
                        <el-input placeholder=""   type="textarea"
                                  :autosize="{minRows: 4,maxRows: 4}"
                                  clearable style="width: 900px;" v-model="feedForm.sendBox">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="0" style="height: 45px">
                <el-col :span="23">
                </el-col>
            </el-row>
            <el-row :gutter="0">
                <el-col :span="23">
                    <el-form-item label-width="100px" label="內部備註：">
                        <el-input placeholder=""   type="textarea"
                                  :autosize="{minRows: 4,maxRows: 4}"
                                  clearable style="width: 900px;" v-model="feedForm.internal">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="0" style="height: 40px">
                <el-col :span="23">
                </el-col>
            </el-row>
            <el-row :gutter="0">
                <el-col :span="23">
                <el-button size="small" type="primary" style="float: left;margin-bottom: 5px;margin-left: 15px;margin-top:10px;" v-if="feedForm.status==0 && canImport" @click="feedSave(1)" v-loading="this.loadingSave">確認入倉</el-button>
                <el-button size="small" type="primary" style="float: left;margin-bottom: 5px;margin-left: 15px;margin-top:10px;" v-if="feedForm.status==0"@click="feedSave(0)" v-loading="this.loadingSave">保存</el-button>
                <el-button size="small" type="primary" style="float: left;margin-bottom: 5px;margin-left: 15px;margin-top:10px;" v-if="feedForm.status==1" @click="updateFeedSave()">保存</el-button>
                <el-button size="small" type="primary" style="float: left;margin-bottom: 5px;margin-left: 15px;margin-top:10px;"  @click="goBack">返回</el-button>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
    import axios from 'axios'
    import {updateFeedDate,getFeedById,insertFeedBack,getRollingListById,updateFeedSave} from '../api/api'
    export default {
        data() {

            return {
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                disabledNum:false,
                feedForm:{
                    id:'',
                    feedDate:'',
                    carNumber:'',
                    pitPaper:'',  //坑紙
                    newsPaper:'',  //报纸
                    buBu:'',
                    copyPaper:'',
                    mat:'',     //毡
                    tinFoil:'', //保鲜纸
                    azusa:'',
                    shortWood:'',  //矮木
                    ironCar:'',
                    toGlue:'',
                    softPaper:'',
                    lousyPaper:'',//烂纸
                    moistureproof:'',
                    electric:'',
                    gummedPaper:'',
                    big:'',
                    inthe:'',
                    fine:'',
                    oldBig:'',
                    oldInthe:'',
                    oldFine:'',
                    plasma:'',
                    crepePaper:'',
                    flatClothing:'',//平衣
                    refrigerator:'',
                    elastic:'',//黑色橡筋
                    cardboard:'',
                    stiff:'',
                    bulktank:'',
                    paperCardBoard:'',
                    threeSeats:'',
                    twoSeats:'',
                    oneSeats:'',
                    threeRuler:'',
                    fourRuler:'',
                    fiveRuler:'',
                    sixRuler:'',
                    oneSmall:'',
                    small:'',
                    tool:'',
                    glue:'',
                    toCounter:'',
                    cage:'', //铁笼
                    theWire:'',
                    plywood:'',
                    oneGlue:'',
                    wireMesh:'',
                    productCar:'',
                    tape:'',
                    other:'',
                    status:'',
                    oneCar:'',
                    twoCar:'',
                    threeCar:'',
                    smooth:'',
                    lengthFloor:'',
                    shortFloor:'',
                    fork:'',
                    chelsea:'',
                    sendBox:'',
                    oneOther:'',
                    internal:''
                },
                acctId:'',
                feedRules:{
                    feedDate:[
                        {required: true, message: '日期不能為空', trigger: 'change' },
                    ],
                    carNumber:[
                        {required: true, message: '車號不能為空', trigger: 'change' },
                    ],
                  /*  oneCar:[
                        {required: true, message: '扎車坑紙不能為空', trigger: 'change' },
                    ],
                    twoCar:[
                        {required: true, message: '扎車地膠不能為空', trigger: 'change' },
                    ],
                    threeCar:[
                        {required: true, message: '扎車縐紋紙不能為空', trigger: 'change' },
                    ],*/
                },
                rollingId:0,
                loadingSave:false,
                feedOldForm:{
                    oldfork:'',
                    oldchelsea:'',
                    oldpitPaper:'',  //坑紙
                    oldnewsPaper:'',  //报纸
                    oldbuBu:'',
                    oldcopyPaper:'',
                    oldmat:'',     //毡
                    oldtinFoil:'', //保鲜纸
                    oldazusa:'',
                    oldshortWood:'',  //矮木
                    oldironCar:'',
                    oldtoGlue:'',
                    oldsoftPaper:'',
                    oldlousyPaper:'',//烂纸
                    oldmoistureproof:'',
                    oldelectric:'',
                    oldgummedPaper:'',
                    agedbig:'',
                    agedinthe:'',
                    agedfine:'',
                    oldoldBig:'',
                    oldoldInthe:'',
                    oldoldFine:'',
                    oldplasma:'',
                    oldcrepePaper:'',
                    oldflatClothing:'',//平衣
                    oldrefrigerator:'',
                    oldelastic:'',//黑色橡筋
                    oldcardboard:'',
                    oldstiff:'',
                    oldbulktank:'',
                    oldpaperCardBoard:'',
                    oldthreeSeats:'',
                    oldtwoSeats:'',
                    oldoneSeats:'',
                    oldthreeRuler:'',
                    oldfourRuler:'',
                    oldfiveRuler:'',
                    oldsixRuler:'',
                    oldoneSmall:'',
                    oldsmall:'',
                    oldtool:'',
                    oldglue:'',
                    oldtoCounter:'',
                    oldcage:'', //铁笼
                    oldtheWire:'',
                    oldplywood:'',
                    oldoneGlue:'',
                    oldwireMesh:'',
                    oldproductCar:'',
                    oldtape:'',
                    oldother:'',
                    oldstatus:'',
                    oldoneCar:'',
                    oldtwoCar:'',
                    oldthreeCar:'',
                    oldsmooth:'',
                    oldlengthFloor:'',
                    oldshortFloor:''
                },
                paramsFeedId:'',
                updateFeedId:0
            }
        },
        methods: {
            initalFeeding(){
                this.disabledNum=false;
                this.feedForm={
                    id:'',
                        feedDate:'',
                        carNumber:'',
                        pitPaper:'',  //坑紙
                        newsPaper:'',  //报纸
                        buBu:'',
                        copyPaper:'',
                        mat:'',     //毡
                        tinFoil:'', //保鲜纸
                        azusa:'',
                        shortWood:'',  //矮木
                        ironCar:'',
                        toGlue:'',
                        softPaper:'',
                        lousyPaper:'',//烂纸
                        moistureproof:'',
                        electric:'',
                        gummedPaper:'',
                        big:'',
                        inthe:'',
                        fine:'',
                        oldBig:'',
                        oldInthe:'',
                        oldFine:'',
                        plasma:'',
                        crepePaper:'',
                        flatClothing:'',//平衣
                        refrigerator:'',
                        elastic:'',//黑色橡筋
                        cardboard:'',
                        stiff:'',
                        bulktank:'',
                        paperCardBoard:'',
                        threeSeats:'',
                        twoSeats:'',
                        oneSeats:'',
                        threeRuler:'',
                        fourRuler:'',
                        fiveRuler:'',
                        sixRuler:'',
                        oneSmall:'',
                        small:'',
                        tool:'',
                        glue:'',
                        toCounter:'',
                        cage:'', //铁笼
                        theWire:'',
                        plywood:'',
                        oneGlue:'',
                        wireMesh:'',
                        productCar:'',
                        tape:'',
                        other:'',
                        status:'',
                        oneCar:'',
                        twoCar:'',
                        threeCar:'',
                        smooth:'',
                        lengthFloor:'',
                        shortFloor:'',
                        fork:'',
                        chelsea:'',
                        sendBox:'',
                        oneOther:'',
                        internal:''
                },
                this.acctId='';
                this.rollingId=0;
            },
            updateFeedSave(){
                if (this.feedForm.feedDate == '') {
                    this.feedForm.feedDate = 0
                }
                var params = Object.assign({}, this.feedForm);
                params.feedDate = Math.round(new Date(params.feedDate).getTime() / 1000);
                params.rollingId=this.rollingId;
                updateFeedSave(params).then(data => {
                    let {errcode, errmsg} = data.data;
                    if (errcode == 200) {
                        this.$message.success("保存成功");
                        this.resetForm("feedForm");
                        this.acctId = '';
                        this.rollingId=0;
                        this.updateFeedId=0;
                        this.initalFeeding();
                        this.$router.push({
                            name: '物料出入倉',
                            params: {str: new Date().getTime()}
                        })
                        this.$store.commit("closeTab", 'feedEdit');
                    } else {
                        this.$message.error("保存失败");
                    }
                },);
            },
            validateChange(ev,bigvalue,oneCar){
                if(ev!=null && ev!=''){
                    var re=/^[0-9]\d*\.{0,1}\d{0,2}$/;
                    if(!re.test(ev)){
                        if(oneCar=="pitPaper") {
                            this.feedForm.pitPaper = ""; //坑紙
                        }if(oneCar=="newsPaper") {
                            this.feedForm.newsPaper = "";  //报纸
                        }if(oneCar=="buBu") {
                            this.feedForm.buBu = "";
                        }if(oneCar=="copyPaper") {
                            this.feedForm.copyPaper = "";
                        }if(oneCar=="mat") {
                            this.feedForm.mat = "";    //毡
                        }if(oneCar=="tinFoil") {
                            this.feedForm.tinFoil = "";//保鲜纸
                        }if(oneCar=="azusa"){
                           this.feedForm.azusa="";
                        }if(oneCar=="shortWood"){
                        this.feedForm.shortWood="";  //矮木
                        }if(oneCar=="ironCar"){
                        this.feedForm.ironCar="";
                        }if(oneCar=="toGlue"){
                        this.feedForm.toGlue="";
                        }if(oneCar=="softPaper"){
                        this.feedForm.softPaper="";
                        }if(oneCar=="lousyPaper"){
                        this.feedForm.lousyPaper="";//烂纸
                        }if(oneCar=="moistureproof"){
                        this.feedForm.moistureproof="";
                        }if(oneCar=="electric"){
                        this.feedForm.electric="";
                        }if(oneCar=="gummedPaper"){
                        this.feedForm.gummedPaper="";
                        }if(oneCar=="big"){
                        this.feedForm.big="";
                        }if(oneCar=="inthe"){
                        this.feedForm.inthe="";
                        }if(oneCar=="fine"){
                        this.feedForm.fine="";
                        }if(oneCar=="oldBig"){
                        this.feedForm.oldBig="";
                        }if(oneCar=="oldInthe"){
                        this.feedForm.oldInthe="";
                        }if(oneCar=="oldFine"){
                        this.feedForm.oldFine="";
                        }if(oneCar=="plasma"){
                        this.feedForm.plasma="";
                        }if(oneCar=="crepePaper"){
                        this.feedForm.crepePaper="";
                        }if(oneCar=="flatClothing"){
                        this.feedForm.flatClothing="";//平衣
                        }if(oneCar=="refrigerator"){
                        this.feedForm.refrigerator="";
                        }if(oneCar=="elastic"){
                        this.feedForm.elastic="";//黑色橡筋
                        }if(oneCar=="cardboard"){
                        this.feedForm.cardboard="";
                        }if(oneCar=="stiff"){
                        this.feedForm.stiff="";
                        }if(oneCar=="bulktank"){
                        this.feedForm.bulktank="";
                        }if(oneCar=="paperCardBoard"){
                        this.feedForm.paperCardBoard="";
                        }if(oneCar=="threeSeats"){
                        this.feedForm.threeSeats="";
                        }if(oneCar=="twoSeats"){
                        this.feedForm.twoSeats="";
                        }if(oneCar=="oneSeats"){
                        this.feedForm.oneSeats="";
                        }if(oneCar=="threeRuler"){
                        this.feedForm.threeRuler="";
                        }if(oneCar=="fourRuler"){
                        this.feedForm.fourRuler="";
                        }if(oneCar=="fiveRuler"){
                        this.feedForm.fiveRuler="";
                        }if(oneCar=="sixRuler"){
                        this.feedForm.sixRuler="";
                        }if(oneCar=="oneSmall"){
                        this.feedForm.oneSmall="";
                        }if(oneCar=="small"){
                        this.feedForm.small="";
                        }if(oneCar=="tool"){
                        this.feedForm.tool="";
                        }if(oneCar=="glue"){
                        this.feedForm.glue="";
                        }if(oneCar=="toCounter"){
                        this.feedForm.toCounter="";
                        }if(oneCar=="cage"){
                        this.feedForm.cage=""; //铁笼
                        }if(oneCar=="theWire"){
                        this.feedForm.theWire="";
                        }if(oneCar=="plywood"){
                        this.feedForm.plywood="";
                        }if(oneCar=="oneGlue"){
                        this.feedForm.oneGlue="";
                        }if(oneCar=="wireMesh"){
                        this.feedForm.wireMesh="";
                        }if(oneCar=="productCar"){
                        this.feedForm.productCar="";
                        }if(oneCar=="tape"){
                        this.feedForm.tape="";
                        }if(oneCar=="oneCar"){
                        this.feedForm.oneCar="";
                        }if(oneCar=="twoCar"){
                        this.feedForm.twoCar="";
                        }if(oneCar=="threeCar"){
                        this.feedForm.threeCar="";
                        }if(oneCar=="smooth"){
                        this.feedForm.smooth="";
                        }if(oneCar=="lengthFloor"){
                        this.feedForm.lengthFloor="";
                        }if(oneCar=="shortFloor"){
                        this.feedForm.shortFloor="";
                        }if(oneCar=="fork"){
                        this.feedForm.fork="";
                        }if(oneCar=="chelsea") {
                            this.feedForm.chelsea = "";
                        }
                        return this.$message.error("請輸入正確的格式，數字只有2位小數");
                    }else{
                        if(parseFloat(ev)>parseFloat(bigvalue)){
                            if(oneCar=="pitPaper") {
                                this.feedForm.pitPaper = ""; //坑紙
                            }if(oneCar=="newsPaper") {
                                this.feedForm.newsPaper = "";  //报纸
                            }if(oneCar=="buBu") {
                                this.feedForm.buBu = "";
                            }if(oneCar=="copyPaper") {
                                this.feedForm.copyPaper = "";
                            }if(oneCar=="mat") {
                                this.feedForm.mat = "";    //毡
                            }if(oneCar=="tinFoil") {
                                this.feedForm.tinFoil = "";//保鲜纸
                            }if(oneCar=="azusa"){
                                this.feedForm.azusa="";
                            }if(oneCar=="shortWood"){
                                this.feedForm.shortWood="";  //矮木
                            }if(oneCar=="ironCar"){
                                this.feedForm.ironCar="";
                            }if(oneCar=="toGlue"){
                                this.feedForm.toGlue="";
                            }if(oneCar=="softPaper"){
                                this.feedForm.softPaper="";
                            }if(oneCar=="lousyPaper"){
                                this.feedForm.lousyPaper="";//烂纸
                            }if(oneCar=="moistureproof"){
                                this.feedForm.moistureproof="";
                            }if(oneCar=="electric"){
                                this.feedForm.electric="";
                            }if(oneCar=="gummedPaper"){
                                this.feedForm.gummedPaper="";
                            }if(oneCar=="big"){
                                this.feedForm.big="";
                            }if(oneCar=="inthe"){
                                this.feedForm.inthe="";
                            }if(oneCar=="fine"){
                                this.feedForm.fine="";
                            }if(oneCar=="oldBig"){
                                this.feedForm.oldBig="";
                            }if(oneCar=="oldInthe"){
                                this.feedForm.oldInthe="";
                            }if(oneCar=="oldFine"){
                                this.feedForm.oldFine="";
                            }if(oneCar=="plasma"){
                                this.feedForm.plasma="";
                            }if(oneCar=="crepePaper"){
                                this.feedForm.crepePaper="";
                            }if(oneCar=="flatClothing"){
                                this.feedForm.flatClothing="";//平衣
                            }if(oneCar=="refrigerator"){
                                this.feedForm.refrigerator="";
                            }if(oneCar=="elastic"){
                                this.feedForm.elastic="";//黑色橡筋
                            }if(oneCar=="cardboard"){
                                this.feedForm.cardboard="";
                            }if(oneCar=="stiff"){
                                this.feedForm.stiff="";
                            }if(oneCar=="bulktank"){
                                this.feedForm.bulktank="";
                            }if(oneCar=="paperCardBoard"){
                                this.feedForm.paperCardBoard="";
                            }if(oneCar=="threeSeats"){
                                this.feedForm.threeSeats="";
                            }if(oneCar=="twoSeats"){
                                this.feedForm.twoSeats="";
                            }if(oneCar=="oneSeats"){
                                this.feedForm.oneSeats="";
                            }if(oneCar=="threeRuler"){
                                this.feedForm.threeRuler="";
                            }if(oneCar=="fourRuler"){
                                this.feedForm.fourRuler="";
                            }if(oneCar=="fiveRuler"){
                                this.feedForm.fiveRuler="";
                            }if(oneCar=="sixRuler"){
                                this.feedForm.sixRuler="";
                            }if(oneCar=="oneSmall"){
                                this.feedForm.oneSmall="";
                            }if(oneCar=="small"){
                                this.feedForm.small="";
                            }if(oneCar=="tool"){
                                this.feedForm.tool="";
                            }if(oneCar=="glue"){
                                this.feedForm.glue="";
                            }if(oneCar=="toCounter"){
                                this.feedForm.toCounter="";
                            }if(oneCar=="cage"){
                                this.feedForm.cage=""; //铁笼
                            }if(oneCar=="theWire"){
                                this.feedForm.theWire="";
                            }if(oneCar=="plywood"){
                                this.feedForm.plywood="";
                            }if(oneCar=="oneGlue"){
                                this.feedForm.oneGlue="";
                            }if(oneCar=="wireMesh"){
                                this.feedForm.wireMesh="";
                            }if(oneCar=="productCar"){
                                this.feedForm.productCar="";
                            }if(oneCar=="tape"){
                                this.feedForm.tape="";
                            }if(oneCar=="oneCar"){
                                this.feedForm.oneCar="";
                            }if(oneCar=="twoCar"){
                                this.feedForm.twoCar="";
                            }if(oneCar=="threeCar"){
                                this.feedForm.threeCar="";
                            }if(oneCar=="smooth"){
                                this.feedForm.smooth="";
                            }if(oneCar=="lengthFloor"){
                                this.feedForm.lengthFloor="";
                            }if(oneCar=="shortFloor"){
                                this.feedForm.shortFloor="";
                            }if(oneCar=="fork"){
                                this.feedForm.fork="";
                            }if(oneCar=="chelsea") {
                                this.feedForm.chelsea = "";
                            }
                            return this.$message.error("入倉數量不能大於出倉數量");
                        }
                    }
                }
            },
            resetForm(formName){
                if (this.$refs[formName] !== undefined) {
                    this.$refs[formName].resetFields();
                }
            },
            feedSave(ev){
                if(ev==1){
                    this.$confirm(this.$t('m.m_Importconfirm'), this.$t('m.m_info'), {
                        confirmButtonText: this.$t('m.t_confirm'),
                        cancelButtonText: this.$t('m.b_cancel'),
                        type: 'warning'
                    }).then(() => {
                        this.feedBackSave(ev);
                    });
                }else{
                    this.feedBackSave(ev);
                }
            },
            feedBackSave(ev){
                this.$refs.feedForm.validate((valid) => {
                   if (valid) {
                       this.loadingSave=true;
                       if (this.feedForm.feedDate == '') {
                           this.feedForm.feedDate = 0
                       }
                       var params = Object.assign({}, this.feedForm);
                       params.feedDate = Math.round(new Date(params.feedDate).getTime() / 1000);
                       params.rollingId=this.rollingId;
                       params.status = ev;
                      /* if (this.feedForm.id=='' || this.feedForm.id==null) {
                           insertFeedBack(params).then(data => {
                               let {errcode, errmsg} = data.data;
                               if (errcode == 200) {
                                   this.$message.success("保存成功");
                                   this.resetForm("feedForm");
                                   this.$router.push({
                                       name: '物料出入倉',
                                       params: {str: new Date().getTime()}
                                   })
                                   this.$store.commit("closeTab", 'feedEdit');
                               } else {
                                   this.$message.error("保存失败");
                               }
                           },);
                       } else {*/
                           updateFeedDate(params).then(data => {
                               let {errcode, errmsg} = data.data;
                               if (errcode == 200) {
                                   if (ev == 1) {
                                       this.$message.success("入倉成功");
                                   } else {
                                       this.$message.success("保存成功");
                                   }
                                   this.loadingSave=false;
                                   this.resetForm("feedForm");
                                   this.acctId = '';
                                   this.rollingId=0;
                                   this.updateFeedId=0;
                                   this.initalFeeding();
                                   this.$router.push({
                                       name: '物料出入倉',
                                       params: {str: new Date().getTime()}
                                   })
                                   this.$store.commit("closeTab", 'feedEdit');
                               } else {
                                   this.$message.error("保存失败");
                                   this.loadingSave=false;
                               }
                           },);
                       //}
                   }
                });
            },
            goBack(){
                this.$router.push({
                    name:'物料出入倉',
                    params:{str:new Date().getTime()}
                })
                this.$store.commit("closeTab","feedEdit");
                this.initalFeeding();
                this.updateFeedId=0;
            },
            getFeedParams(){
                this.disabledNum=false;
                this.initalFeeding();
                if (this.acctId == '') {
                    this.acctId = this.$route.params.feedId;
                    if (this.acctId != ''&& this.acctId != null && this.acctId != undefined) {
                        this.queryOneAcctRec(this.acctId);
                    }
                }
                if (this.acctId != this.$route.params.feedId && this.$route.params.feedId != undefined) {
                    this.acctId = this.$route.params.feedId;
                    this.queryOneAcctRec(this.acctId);
                }

                if (this.rollingId == 0) {
                    this.rollingId = this.$route.params.rollId;
                    if (this.rollingId != ''&& this.rollingId != null && this.rollingId != undefined) {
                        this.paramsFeedId=this.rollingId;
                        this.queryOneRollList(this.rollingId);
                    }
                }
                if (this.rollingId != this.$route.params.rollId && this.$route.params.rollId != undefined) {
                    this.rollingId = this.$route.params.rollId;
                    this.paramsFeedId=this.rollingId;
                    this.queryOneRollList(this.rollingId);
                }
            },
            queryOneRollList(acctId){
                if(acctId!=undefined) {
                    return getRollingListById(acctId).then(data => {
                        let item = data.data;
                        if (item != null) {
                            if(this.disabledNum!=true) {
                                if (item.data.feedDate == null || item.data.feedDate == '' || item.data.feedDate == 0) {
                                    this.feedForm.feedDate = "";
                                } else {
                                    this.feedForm.feedDate = new Date(item.data.feedDate * 1000);
                                }
                                this.feedForm.carNumber = item.data.carNumber;
                                this.feedOldForm.oldoneCar = item.data.oneCar == 0 ? '' : item.data.oneCar;
                                this.feedOldForm.oldtwoCar = item.data.twoCar == 0 ? '' : item.data.twoCar;
                                this.feedOldForm.oldthreeCar = item.data.threeCar == 0 ? '' : item.data.threeCar;
                            }

                            if(this.acctId=='' || this.acctId==null){
                                this.feedForm.sendBox= item.data.sendBox;
                                this.feedForm.oneOther = item.data.oneOther;
                                this.feedForm.internal=item.data.internal;
                            }
                            if(this.disabledNum!=true) {
                            if (item.data.rollingItem != null) {
                                let tempList = item.data.rollingItem;
                                for (let i = 0; i < tempList.length; i++) {
                                    let poiItem = tempList[i];
                                    Object.assign({}, this.feedOldForm);
                                    if(poiItem.pitPaper == 0){
                                        this.feedOldForm.oldpitPaper = '';  //坑紙
                                    }else{
                                        if(item.data.oneCar==0){
                                            this.feedOldForm.oldpitPaper = parseFloat(poiItem.pitPaper);  //坑紙
                                        }else{
                                            this.feedOldForm.oldpitPaper = parseFloat(poiItem.pitPaper)+parseFloat(item.data.oneCar);  //坑紙
                                        }
                                    }
                                    if(poiItem.toGlue == 0){
                                        this.feedOldForm.oldtoGlue = '';  //地膠
                                    }else{
                                        if(item.data.twoCar==0){
                                            this.feedOldForm.oldtoGlue = parseFloat(poiItem.toGlue);  //地膠
                                        }else{
                                            this.feedOldForm.oldtoGlue = parseFloat(poiItem.toGlue)+parseFloat(item.data.twoCar);  //地膠
                                        }
                                    }
                                    if(poiItem.crepePaper == 0){
                                        this.feedOldForm.oldcrepePaper = '';  //縐紋紙
                                    }else{
                                        if(item.data.threeCar==0){
                                            this.feedOldForm.oldcrepePaper = parseFloat(poiItem.crepePaper);  //縐紋紙
                                        }else{
                                            this.feedOldForm.oldcrepePaper = parseFloat(poiItem.crepePaper)+parseFloat(item.data.threeCar);  //縐紋紙
                                        }
                                    }
                                    this.feedOldForm.oldnewsPaper = poiItem.newsPaper == 0 ? '' : poiItem.newsPaper;  //报纸
                                    this.feedOldForm.oldbuBu = poiItem.buBu == 0 ? '' : poiItem.buBu;
                                    this.feedOldForm.oldcopyPaper = poiItem.copyPaper == 0 ? '' : poiItem.copyPaper;
                                    this.feedOldForm.oldmat = poiItem.mat == 0 ? '' : poiItem.mat;     //毡
                                    this.feedOldForm.oldtinFoil = poiItem.tinFoil == 0 ? '' : poiItem.tinFoil; //保鲜纸
                                    this.feedOldForm.oldazusa = poiItem.azusa == 0 ? '' : poiItem.azusa;
                                    this.feedOldForm.oldshortWood = poiItem.shortWood == 0 ? '' : poiItem.shortWood;  //矮木
                                    this.feedOldForm.oldironCar = poiItem.ironCar == 0 ? '' : poiItem.ironCar;
                                    this.feedOldForm.oldsoftPaper = poiItem.softPaper == 0 ? '' : poiItem.softPaper;
                                    this.feedOldForm.oldlousyPaper = poiItem.lousyPaper == 0 ? '' : poiItem.lousyPaper;//烂纸
                                    this.feedOldForm.oldmoistureproof = poiItem.moistureproof == 0 ? '' : poiItem.moistureproof;
                                    this.feedOldForm.oldelectric = poiItem.electric == 0 ? '' : poiItem.electric;
                                    this.feedOldForm.oldgummedPaper = poiItem.gummedPaper == 0 ? '' : poiItem.gummedPaper;
                                    this.feedOldForm.agedbig = poiItem.big == 0 ? '' : poiItem.big;
                                    this.feedOldForm.agedinthe = poiItem.inthe == 0 ? '' : poiItem.inthe;
                                    this.feedOldForm.agedfine = poiItem.fine == 0 ? '' : poiItem.fine;
                                    this.feedOldForm.oldoldBig = poiItem.oldBig == 0 ? '' : poiItem.oldBig;
                                    this.feedOldForm.oldoldInthe = poiItem.oldInthe == 0 ? '' : poiItem.oldInthe;
                                    this.feedOldForm.oldoldFine = poiItem.oldFine == 0 ? '' : poiItem.oldFine;
                                    this.feedOldForm.oldplasma = poiItem.plasma == 0 ? '' : poiItem.plasma;
                                    this.feedOldForm.oldflatClothing = poiItem.flatClothing == 0 ? '' : poiItem.flatClothing;//平衣
                                    this.feedOldForm.oldrefrigerator = poiItem.refrigerator == 0 ? '' : poiItem.refrigerator;
                                    this.feedOldForm.oldelastic = poiItem.elastic == 0 ? '' : poiItem.elastic;//黑色橡筋
                                    this.feedOldForm.oldcardboard = poiItem.cardboard == 0 ? '' : poiItem.cardboard;
                                    this.feedOldForm.oldstiff = poiItem.stiff == 0 ? '' : poiItem.stiff;
                                    this.feedOldForm.oldbulktank = poiItem.bulktank == 0 ? '' : poiItem.bulktank;
                                    this.feedOldForm.oldpaperCardBoard = poiItem.paperCardBoard == 0 ? '' : poiItem.paperCardBoard;
                                    this.feedOldForm.oldthreeSeats = poiItem.threeSeats == 0 ? '' : poiItem.threeSeats;
                                    this.feedOldForm.oldtwoSeats = poiItem.twoSeats == 0 ? '' : poiItem.twoSeats;
                                    this.feedOldForm.oldoneSeats = poiItem.oneSeats == 0 ? '' : poiItem.oneSeats;
                                    this.feedOldForm.oldthreeRuler = poiItem.threeRuler == 0 ? '' : poiItem.threeRuler;
                                    this.feedOldForm.oldfourRuler = poiItem.fourRuler == 0 ? '' : poiItem.fourRuler;
                                    this.feedOldForm.oldfiveRuler = poiItem.fiveRuler == 0 ? '' : poiItem.fiveRuler;
                                    this.feedOldForm.oldsixRuler = poiItem.sixRuler == 0 ? '' : poiItem.sixRuler;
                                    this.feedOldForm.oldoneSmall = poiItem.oneSmall == 0 ? '' : poiItem.oneSmall;
                                    this.feedOldForm.oldsmall = poiItem.small == 0 ? '' : poiItem.small;
                                    this.feedOldForm.oldtool = poiItem.tool == 0 ? '' : poiItem.tool;
                                    this.feedOldForm.oldglue = poiItem.glue == 0 ? '' : poiItem.glue;
                                    this.feedOldForm.oldtoCounter = poiItem.toCounter == 0 ? '' : poiItem.toCounter;
                                    this.feedOldForm.oldcage = poiItem.cage == 0 ? '' : poiItem.cage; //铁笼
                                    this.feedOldForm.oldtheWire = poiItem.theWire == 0 ? '' : poiItem.theWire;
                                    this.feedOldForm.oldplywood = poiItem.plywood == 0 ? '' : poiItem.plywood;
                                    this.feedOldForm.oldoneGlue = poiItem.oneGlue == 0 ? '' : poiItem.oneGlue;
                                    this.feedOldForm.oldwireMesh = poiItem.wireMesh == 0 ? '' : poiItem.wireMesh;
                                    this.feedOldForm.oldproductCar = poiItem.productCar == 0 ? '' : poiItem.productCar;
                                    this.feedOldForm.oldtape = poiItem.tape == 0 ? '' : poiItem.tape;
                                    this.feedOldForm.oldother = poiItem.other == 0 ? '' : poiItem.other;
                                    this.feedOldForm.oldstatus = poiItem.status == 0 ? '' : poiItem.status;
                                    this.feedOldForm.oldsmooth = poiItem.smooth == 0 ? '' : poiItem.smooth;
                                    this.feedOldForm.oldlengthFloor = poiItem.lengthFloor == 0 ? '' : poiItem.lengthFloor;
                                    this.feedOldForm.oldshortFloor = poiItem.shortFloor == 0 ? '' : poiItem.shortFloor;
                                    this.feedOldForm.oldfork = poiItem.fork == 0 ? '' : poiItem.fork;
                                    this.feedOldForm.oldchelsea = poiItem.chelsea == 0 ? '' : poiItem.chelsea;
                            }}}
                        }
                    });
                }
            },
            queryOneAcctRec(acctId){
                if(acctId!=undefined){
                     getFeedById(acctId).then(data => {
                        let item = data.data;
                        if (item != null) {
                            Object.assign(this.feedForm, item.data);
                            if (item.data.feedDate == null || item.data.feedDate == '' || item.data.feedDate == 0) {
                                this.feedForm.feedDate = "";
                            } else {
                                this.feedForm.feedDate = new Date(item.data.feedDate * 1000);
                            }
                            if(item.data.status==1){
                                this.disabledNum=true;
                            }
                        }
                    });
                }
            }
        },
        mounted() {
        },
        activated(){
            let outId = this.$route.params.rollId;
            if (outId!= '' && outId!= null &&  outId!= undefined) {
                if(outId!= this.paramsFeedId && this.updateFeedId==0){
                    this.disabledNum=false;
                    this.getFeedParams();
                }else if(outId== this.paramsFeedId && this.updateFeedId==0){
                    this.disabledNum=false;
                    this.getFeedParams();
                }
            }
            this.updateFeedId=1;
        },
        computed: {
            canImport(){
                return this.$store.getters.hasPermission("ROLL_IMPORT");
            }
        }
    }

</script>

<style lang="scss">
    .el-col-4{
        height: 35px;
    }
    .el-col-23{
        height: 35px;
    }
    .el-col-16{
        height: 35px;
    }
    .menu {
        .right {
            float: right;
        }
    }
    .el-tag + .el-tag {
        margin-left: 5px;
    }

    .dataListTable .cell {
        white-space: nowrap;
    }
</style>



// WEBPACK FOOTER //
// src/views/UpdateFeedBack.vue